import DynamicCell, { DynamicCellProps } from '@/common/Table/cells/DynamicCell';

import { ReactElement } from 'react';
import cellRenderers from '@/pages/Reports/DynamicReport/components/ReportTable/components/ReportTableCellRenderers';
import { getClasses } from '@/utils';

export type ReportTableCellProps = Omit<DynamicCellProps, 'renderers'>;

const ReportTableCell = ({ className, children, ...props }: ReportTableCellProps): ReactElement => (
  <DynamicCell {...props} className={getClasses('ReportTableCell', className)} renderers={cellRenderers} data-placeholder="--">
    {children}
  </DynamicCell>
);

export default ReportTableCell;
